var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showPreloader ? _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "preloader-container"
  }, [_vm.configuration.enableSnapshotService ? _c('div', {
    attrs: {
      "id": "snapshot-image-scene"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "preloader-container-logo"
  }, [_vm.customsAssetsEndpoint ? _c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssetsEndpoint).concat(_vm.passcodeLogo),
      "alt": ""
    }
  }) : _vm._e()]), _c(_vm.activePreloaderComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.activeComponentProps, false))], 1), _vm.configuration.enableNewNoWebglModal ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '80%',
      "maxWidthModal": 500,
      "modal-name": "noWebglModal",
      "cta-primary-button": "oldBrowserCta"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$refs.content.ctaAction();
      }
    }
  }, [_c('no-webgl-modal', {
    ref: "content"
  })], 1) : _c('modal-wrapper', {
    attrs: {
      "widthModal": '80%',
      "title": "noWebglHeader",
      "modal-name": "noWebglModal",
      "content-component": "noWebglModal",
      "ctaButton": "noWebglBetterBrowser"
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }